import { KiaPage_Pagebuilder_Blocks_CarCarouselGrid_SelectedCars } from '../../graphql/generated/graphql';

export const getCarModel = (
  cars: KiaPage_Pagebuilder_Blocks_CarCarouselGrid_SelectedCars[],
) => {
  if (cars.length < 0) return null;
  const models: string[] = [];
  const trims: string[] = [];

  cars.forEach((c) => {
    const afterSemi = c.kiaTrims?.split(';')[1];
    const [model, trim] = afterSemi?.split(',') ?? [];

    models.push(model);
    trims.push(trim);
  });

  return {
    models: models.join(','),
    trims: trims.join(','),
  };
};

export const formatFields = (...fields: Array<string | string[]>) => {
  return fields.flat().join(',');
};
